
export class Expendedora{
    codigoExpendedora : string;
    nombreExpendedora: string;
}
